import ConfirmModal from '@/components/modals/ConfirmModal';

// @vuese
// Mixin modala potwierdzenia
export const confirmModalMixin = {
  components: { ConfirmModal },

  data() {
    return {
      submitData: undefined,
      confirmModalVisible: false
    };
  },

  methods: {
    // @vuese
    // Pokazuje modal do potwierdzenia
    showConfirmModal(data) {
      this.submitData = data;
      this.$set(this, 'confirmModalVisible', true);
    },
    // @vuese
    // Chowa modal
    hideConfirmModal() {
      this.$set(this, 'confirmModalVisible', false);
    }
  }
};
